// src/app/core/store/profile/profile.effects.ts

import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of, EMPTY, forkJoin } from 'rxjs';
import { exhaustMap, map, catchError, withLatestFrom } from 'rxjs/operators';

import { TranslateService } from '@ngx-translate/core';

import { AccountService, UserProfile } from '@core/services/account.service';
import { isCacheValid } from './profile.state';
import { ProfileActions } from './profile.actions';
import { selectProfileSlice } from './profile.selectors';

@Injectable()
export class ProfileEffects {
  private readonly actions$   = inject(Actions);
  private readonly store      = inject(Store);
  private readonly account    = inject(AccountService);
  private readonly translate  = inject(TranslateService);

  private readError(err: unknown): string {
    const e = err as any;
    return e?.error?.message ?? e?.message ?? this.translate.instant('ERRORS.UNEXPECTED_DOT');
  }

  loadProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileActions.load),
      withLatestFrom(this.store.select(selectProfileSlice)),
      exhaustMap(([{ forceReload }, slice]): Observable<Action> => {
        if (!forceReload && isCacheValid(slice.cache)) return EMPTY;

        return forkJoin({
          identity: this.account.getIdentity(),
          permissions: this.account.getPermissions(),
        }).pipe(
          map(({ identity, permissions }) => {
            const data: UserProfile = {
              ...identity,
              teDrejtatNeLLojeTeSigurimeve: permissions.teDrejtatNeLLojeTeSigurimeve ?? [],
              portalPermissions: permissions.portalPermissions ?? [],
            };
            return ProfileActions.success({ data });
          }),
          catchError(err => of(ProfileActions.failure({ error: this.readError(err) }))),
        );
      }),
    )
  );
}
